import api from './api';

export default {
  login(student_number, password) {
    return api.post('/login', {student_number, password})
      .then(({token}) => {
        sessionStorage.setItem('USR', token);
        localStorage.setItem('USR', token);
        sessionStorage.removeItem('SIGN');
      });
  },

  refresh() {
    const token = this.refreshToken;
    return api.post('/refresh', {token})
      .then(({token}) => {
        sessionStorage.setItem('USR', token);
        localStorage.setItem('USR', token);
        sessionStorage.removeItem('SIGN');
      })
      .catch(e => {
        this.logout();
        throw e;
      });
  },

  logout() {
    this.user = null;
    sessionStorage.removeItem('USR');
    sessionStorage.removeItem('SIGN');
    localStorage.removeItem('USR');
  },

  student() {
    return api.get('/students');
  },

  get token() {
    return sessionStorage.getItem('USR');
  },

  get refreshToken() {
    return localStorage.getItem('USR');
  }

};
